import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class FolderModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (FolderModel._instance == null) FolderModel._instance = new FolderModel(authManager);
        return FolderModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'core/folders');

        this.entityName = 'core.Folder';
        this.privileges = {
            create: [["adminFileStorage"],["useFileStorage"]],
            read: [["adminFileStorage"],["useFileStorage"]],
            update: [["adminFileStorage"],["useFileStorage"]],
            delete: [["adminFileStorage"],["useFileStorage"]],
        };

        this.label = 'Folder';
        this.setLabel = 'Folders';

        this.browser = {
            name: 'default-core-folder-browser',
            moduleName: 'default-core-folder-browser',
            moduleTitle: 'Folders',
            moduleStateSlotName: 'default-core-folder-browser',
        };

        this.editor = {
            name: 'default-core-folder-editor',
            moduleName: 'default-core-folder-editor',
            moduleTitle: 'Folder',
            moduleStateSlotName: 'default-core-folder-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'parentFolderId',
                type: 'Folder',
                persistent: true,
                label: 'Parent Folder',
            },
            {
                name: 'parentFolderUid',
                type: 'string',
                persistent: false,
                label: 'Parent Folder UId',
                readOnly: true,
            },
            {
                name: 'permissionsFolderId',
                type: 'Folder',
                persistent: true,
                label: 'Adresář přístupových práv',
            },
            {
                name: 'folderTypeId',
                type: 'FolderType',
                persistent: true,
                label: 'Folder Type',
            },
            {
                name: 'folderTypeLabel',
                type: 'string',
                persistent: false,
                label: 'Folder Type',
                distinctLabel: 'Folder Type (text)',
                readOnly: true,
            },
            {
                name: 'folderTypeIcon',
                type: 'string',
                persistent: false,
                label: 'Icon',
                readOnly: true,
            },
            {
                name: 'folderRole',
                type: 'string',
                persistent: true,
                label: 'Folder Role',
            },
            {
                name: 'ownerId',
                type: 'User',
                persistent: true,
                label: 'Owner',
                distinctLabel: 'Owner (text)',
            },
            {
                name: 'ownerLabel',
                type: 'string',
                persistent: false,
                label: 'Owner',
                distinctLabel: 'Owner (text)',
                readOnly: true,
            },
            {
                name: 'createdAt',
                type: 'utc_datetime',
                persistent: true,
                label: 'Created At',
                readOnly: true,
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'createdById',
                type: 'User',
                persistent: true,
                label: 'Created By',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'updatedAt',
                type: 'utc_datetime',
                persistent: true,
                label: 'Changed At',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'updatedById',
                type: 'User',
                persistent: true,
                label: 'Changed By',
                inEditor: true,
                filterable: true,
            },
        ];

    }

}
